import { SummarySection } from '../SummarySection/SummarySection';
import styles from './SummaryText.module.css';

export const SummaryText = ({ sections }: { sections?: { titulo: string; texto: string }[] }) => {
	if (!sections?.length) {
		return (
			<div className={styles.summaryText}>
				<p>Nenhuma análise disponível.</p>
			</div>
		);
	}

	return (
		<div className={styles.summaryText}>
			{sections.map(({ titulo, texto }) => (
				<SummarySection key={`${titulo}:${texto}`} titulo={titulo} texto={texto} />
			))}
		</div>
	);
};
